/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shipping_Carrier_NameInputs */

const vi_shipping_carrier_name = /** @type {(inputs: Shipping_Carrier_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên đơn vị`)
};

/**

* @param {Shipping_Carrier_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shipping_carrier_name = /** @type {((inputs?: Shipping_Carrier_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shipping_Carrier_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shipping_carrier_name(inputs)
});